import { LingerieIcon } from './LingerieIcon';

/**
 * author: Kristian Mohl
 * id F718A4A1-9D7B-45E5-B0AD-50FDA06BA3C3
 * name lingerie
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lingerie.svg
 * tags
 * - Clothing 
 */
export const BraIcon = LingerieIcon;
export default BraIcon